import { on } from 'delegated-events'

const SELECTORS = Selectors({
  pageSearch: 'page-search',
  filterToggle: 'page-search__toggle',
  filters: 'page-search__filters',
  dependentDropdown: '[data-depends-on]'
})

const $pageSearch = document.querySelector(SELECTORS.asClass('pageSearch'))
const $filterToggle = document.querySelector(SELECTORS.asClass('filterToggle'))
const $filters = document.querySelector(SELECTORS.asClass('filters'))

const fn = {
  init: () => {
    fn.bindEvents()
  },

  bindEvents: () => {
    on('click', SELECTORS.asClass('filterToggle'), fn.handleFilterToggle)

    window.addEventListener('resize', () => {
      if ($filters) {
        $filters.style = null
      }
    })
  },

  handleFilterToggle: (e) => {
    const $button = e.target
    const $target = document.getElementById($button.getAttribute('aria-controls'))

    const expanded = $button.getAttribute('aria-expanded') === 'true'

    $button.setAttribute('aria-expanded', expanded ? 'false' : 'true')
    $filterToggle.classList.toggle('is-active')

    $($target).slideToggle('fast')
  }
}

export default {
  can: () => $pageSearch,
  run: fn.init
}
